/* Judge.me reviews, pulled 2026-10-19 (all published reviews per style, newest first). */
window.REVIEWS = {
 "The Button-Up Beach Tunic": {
  "avg": 4.71,
  "count": 14,
  "reviews": [
   {
    "r": 5.0,
    "a": "Mary Rankin",
    "t": "INCREDIBLE CHIC EASY TO WEAR!",
    "b": "I have purchased several pieces and the fit is amazing and the styles are truly effortless! Traveling they are amazing and minimal wrinkles if any. Love the brand !!!!!",
    "d": "2026-08-19",
    "u": "/products/the-paige-shirt-stripe"
   },
   {
    "r": 5.0,
    "a": "Rachel Walsh",
    "t": "Love this brand",
    "b": "The beach shirt is so comfortable and gorgeous. I bring it everywhere I go all summer. So soft, washes well, steams well. I love it.",
    "d": "2026-08-15",
    "u": "/products/the-paige-beach-shirt"
   },
   {
    "r": 5.0,
    "a": "Sheryl Clark",
    "t": "Beach Shirt and Bridgett Skirt",
    "b": "★★★★★ Absolutely in Love with This Brand I rarely write reviews, but Shoreline has completely won me over. What first drew me in was their beautiful social media presence, it felt elevated, effortless, and authentic. But what made me fall in love with the brand was the connection behind it. Lisa, one of the founders, sends emails personally, and you can genuinely feel the passion, care, and heart that have gone into building this company. In a world of faceless brands, that personal touch means everything. I recently purchased The Beach Shirt and The Bridgett Skirt, and both exceeded my expectations. The Beach Shirt is the perfect cover-up lightweight, breathable, beautifully draped, and effortlessly chic. It instantly became my go-to piece for beach days, poolside lunches, and vacation evenings. My only suggestion? Please make a sleeveless version! I would buy it immediately and probably in every color. The Bridgett Skirt is equally fabulous. It’s comfortable, flattering, and somehow manages to feel both relaxed and elegant at the same time. It’s one of those pieces that makes you feel put together the moment you put it on. Beyond the products, I love Shoreline’s commitment to natural fabrics and conscious sourcing. You can feel the quality in the garments, and it’s refreshing to support a company that’s creating beautiful clothing while staying mindful about how it’s made. Shoreline has become one of those rare brands that delivers on every level: exceptional products, thoughtful design, authentic founder connection, and a brand experience that feels genuinely personal. I’m already planning my next order. — A very happy customer 💙 P.S. Lisa, if you’re reading this: a sleeveless Beach Shirt would be a runaway hit!",
    "d": "2026-06-23",
    "u": "/products/the-paige-beach-shirt"
   },
   {
    "r": 5.0,
    "a": "shala",
    "t": "",
    "b": "Perfect fit- I love everything about this set",
    "d": "2026-04-08",
    "u": "/products/the-paige-shirt-stripe"
   },
   {
    "r": 5.0,
    "a": "Deana Bolton",
    "t": "Love it great quality!  Ordered the green stripe",
    "b": "Love it great quality! Ordered the green stripe set as well",
    "d": "2026-03-10",
    "u": "/products/the-paige-shirt-stripe"
   },
   {
    "r": 5.0,
    "a": "Tameka M",
    "t": "Love Love Love this shirt",
    "b": "Love Love Love this shirt. I purchased it along with the pant. Great quality and love the flow of the fabric. I want to buy every set now.",
    "d": "2026-02-17",
    "u": "/products/the-paige-shirt-stripe"
   },
   {
    "r": 5.0,
    "a": "Olivia Summers",
    "t": "\"Perfect Beach Elegance: Paige Beach Shirt",
    "b": "This beach shirt is a perfect addition to my vacation wardrobe. It fits a little like a tunic, definitely oversized so I sized down in it. Love the fabric and fit.",
    "d": "2024-06-30",
    "u": "/products/the-paige-shirt"
   },
   {
    "r": 5.0,
    "a": "Shannon Mcmann",
    "t": "The Paige",
    "b": "The fabric of this shirt is great quality. Love that it is a fashion staple but the material makes it perfect for a vacation setting.",
    "d": "2024-06-30",
    "u": "/products/the-paige-shirt"
   },
   {
    "r": 5.0,
    "a": "Carie Frank",
    "t": "The Beach Shirt",
    "b": "Great shirt, love the fabric. The fit is a bit oversized but I like that! Don't want anything clingy in the summer heat. Can certainly dress this up or down.",
    "d": "2024-06-30",
    "u": "/products/the-paige-shirt"
   },
   {
    "r": 5.0,
    "a": "Emily",
    "t": "Perfect Buy",
    "b": "The fit is perfect would definitely recommend",
    "d": "2024-05-31",
    "u": "/products/the-paige-shirt"
   },
   {
    "r": 5.0,
    "a": "Jessica M.",
    "t": "Best Value Beach Shirt",
    "b": "\"This is the best beach shirt I've ever owned. It feels amazing, was reasonably priced, and the shipping was incredibly quick.\"",
    "d": "2024-05-14",
    "u": "/products/the-paige-shirt"
   },
   {
    "r": 5.0,
    "a": "Rachel",
    "t": "Highly Recommended",
    "b": "Exceeded all my expectations! This shirt is perfect for travel and I love the material.",
    "d": "2024-04-15",
    "u": "/products/the-paige-shirt"
   },
   {
    "r": 1.0,
    "a": "Shari",
    "t": "",
    "b": "Not the shirt pictured took 7 months to be delivered.",
    "d": "2024-03-23",
    "u": "/products/the-paige-shirt"
   },
   {
    "r": 5.0,
    "a": "Amanda",
    "t": "Top Pick",
    "b": "Love love love this shirt",
    "d": "2024-02-17",
    "u": "/products/the-paige-shirt"
   }
  ]
 },
 "The Shea T-Shirt Dress": {
  "avg": 4.86,
  "count": 14,
  "reviews": [
   {
    "r": 5.0,
    "a": "Isabelle Johnson",
    "t": "LOVE everything about this dress!",
    "b": "I purchased a size small as I am 5’4” and 120lbs. I could have gone smaller but it fit great. I took the dress with me on a Mediterranean cruise to Greece and Italy and it was so gorgeous! Love the fabric as it is see through but it’s also a Swiss suit cover up so totally not meant to war by itself. It was about 1-2” long but I’m also 5’4” so everything’s long on me. Can’t wait to buy the black one also!",
    "d": "2026-09-10",
    "u": "/products/the-shea-t-shirt-dress-white"
   },
   {
    "r": 5.0,
    "a": "Janet Viggiano",
    "t": "white cover-up",
    "b": "love the way it drapes",
    "d": "2026-08-26",
    "u": "/products/the-shea-t-shirt-dress-white"
   },
   {
    "r": 5.0,
    "a": "Kimberly",
    "t": "",
    "b": "Brst dress ever. True to sise",
    "d": "2026-06-15",
    "u": "/products/the-shea-t-shirt-dress"
   },
   {
    "r": 5.0,
    "a": "Charlotta",
    "t": "",
    "b": "Love all your items. So soft and great quality. I will be buying more :)",
    "d": "2026-04-10",
    "u": "/products/the-shea-t-shirt-dress"
   },
   {
    "r": 5.0,
    "a": "Charlotta",
    "t": "",
    "b": "Love all your items. So soft and great quality. I will be buying more :)",
    "d": "2026-04-10",
    "u": "/products/the-shea-t-shirt-dress-white"
   },
   {
    "r": 5.0,
    "a": "Brooke",
    "t": "Great material",
    "b": "Great material, great company.",
    "d": "2026-03-05",
    "u": "/products/the-shea-t-shirt-dress"
   },
   {
    "r": 5.0,
    "a": "Anonymous",
    "t": "The perfect cover up dress - I bought two",
    "b": "The perfect cover up dress - I bought two colors",
    "d": "2026-03-02",
    "u": "/products/the-shea-t-shirt-dress-white"
   },
   {
    "r": 5.0,
    "a": "Stewart Dean",
    "t": "My wife loves the T-Shirt dress",
    "b": "My wife loves the T-Shirt dress. It is very comfortable and looks great on her.",
    "d": "2026-02-17",
    "u": "/products/the-shea-t-shirt-dress-white"
   },
   {
    "r": 5.0,
    "a": "Elizabeth Plumhoff",
    "t": "Fits perfectly",
    "b": "Fits perfectly. Soft and well made.",
    "d": "2026-02-12",
    "u": "/products/the-shea-t-shirt-dress"
   },
   {
    "r": 5.0,
    "a": "Anonymous",
    "t": "Fabulous cover up",
    "b": "Fabulous cover up. True to size. Quick delivery. So happy with the fit. So glad I ordered it. I want it in many colors.",
    "d": "2026-01-28",
    "u": "/products/the-shea-t-shirt-dress-white"
   },
   {
    "r": 5.0,
    "a": "Thonie Borowiak",
    "t": "Beautiful!",
    "b": "Beautiful and sexy! Bought the black and white one.",
    "d": "2025-11-28",
    "u": "/products/the-shea-t-shirt-dress"
   },
   {
    "r": 5.0,
    "a": "Debbie",
    "t": "Great! Will be ordering",
    "b": "Great! Will be ordering more",
    "d": "2025-07-31",
    "u": "/products/the-shea-t-shirt-dress-white"
   },
   {
    "r": 4.0,
    "a": "Michelle",
    "t": "",
    "b": "I took a star away because I have to take it to the seamstress and have the tag at the lower leg removed. It’s in there good and I’m not going to risk ruining it and it shows. Very well made medium fits great. 34C, 5’7 128 lbs.",
    "d": "2025-07-01",
    "u": "/products/the-shea-t-shirt-dress-white"
   },
   {
    "r": 4.0,
    "a": "M.E.",
    "t": "",
    "b": "Great!",
    "d": "2025-05-28",
    "u": "/products/the-shea-t-shirt-dress-white"
   }
  ]
 },
 "The Shea Long Sleeve T-Shirt Dress": {
  "avg": 5.0,
  "count": 1,
  "reviews": [
   {
    "r": 5.0,
    "a": "Karen",
    "t": "",
    "b": "Super comfortable, absolutely love it black-and-white. Hopefully, you guys come out with more colors.",
    "d": "2026-09-22",
    "u": "/products/the-shea-long-sleeve-t-shirt-dress-white"
   }
  ]
 },
 "The Kaitlin Pants": {
  "avg": 4.65,
  "count": 20,
  "reviews": [
   {
    "r": 3.0,
    "a": "Andi",
    "t": "",
    "b": "Too big for xs label and clumsy looking at the buttocks area. The cloth is more wrinkly than it looks. Not worrh the luxury price",
    "d": "2026-09-01",
    "u": "/products/the-kaitlin-pants"
   },
   {
    "r": 5.0,
    "a": "Tameka M",
    "t": "Amazing Sets",
    "b": "I purchased the Kaitlin striped pant and the matching beach shirt. I loved the length of the pants as I am a tall girly and its hard for me to find pants that are long enough and arent too big in the waist. The quality is amazing and makes these pieces worth the price. I look forward to any new releases.",
    "d": "2026-08-25",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Teena Wesley",
    "t": "Love this set",
    "b": "I love the Kaitlyn beach pants and shirt.. it’s a very classy set to wear to the pool or beach.",
    "d": "2026-06-11",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Flora DeCandia",
    "t": "Love the fit really compliments you're body",
    "b": "Love the fit really compliments the body",
    "d": "2026-04-16",
    "u": "/products/the-hailey-trouser"
   },
   {
    "r": 5.0,
    "a": "Charlotta",
    "t": "",
    "b": "Love all your items. So soft and great quality. I will be buying more :)",
    "d": "2026-04-10",
    "u": "/products/the-hailey-trouser-3"
   },
   {
    "r": 5.0,
    "a": "Charlotta",
    "t": "",
    "b": "Love all your items. So soft and great quality. I will be buying more :)",
    "d": "2026-04-10",
    "u": "/products/the-hailey-trouser-3"
   },
   {
    "r": 5.0,
    "a": "shala",
    "t": "",
    "b": "Perfect fit- i love everything about this set",
    "d": "2026-04-08",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 4.0,
    "a": "Anonymous",
    "t": "Great fabric/color/quality",
    "b": "Great fabric, like the flowiness don't love that they zipper and not just pull on. They are quite long - I'm 5'7 and 150lbs - and the small is a tiny bit tight in the waist mostly due to the zipper, but I wouldn't want them bigger. I like long pants, but these are probably an inch too long - they drag on floor.I don't wear heels around the pool, so they will drag a little but I'm still keeping them",
    "d": "2026-02-18",
    "u": "/products/the-hailey-trouser"
   },
   {
    "r": 5.0,
    "a": "Hilary",
    "t": "",
    "b": "Amazing!!! Love anything i ever order from The Shore Line.",
    "d": "2025-08-12",
    "u": "/products/the-hailey-trouser"
   },
   {
    "r": 5.0,
    "a": "Kourtney",
    "t": "A Resort-Wear Dream – Compliments All Day!",
    "b": "I wore the Hailey Trouser Pants to a resort in St. Barts and wow — I’ve never received so many compliments in one day! These pants are effortlessly stylish and flow beautifully with every step. The lightweight fabric was perfect for the tropical weather, and the cut is incredibly flattering. What truly pulls the look together is the matching top — it creates such a chic, coordinated outfit that’s ideal for lounging poolside or heading out for cocktails. I wore my swimsuit underneath, and it peeked through just enough to give it that effortlessly cool resort vibe. These pants are the definition of elevated resort wear. Stylish, versatile, and absolutely stunning — I’ll be packing them for every getaway!",
    "d": "2025-07-19",
    "u": "/products/the-hailey-trouser-3"
   },
   {
    "r": 5.0,
    "a": "Emily Barfield",
    "t": "GORGEOUS",
    "b": "When I say I’m obsessed with these pants, that’s an understatement. They were on super back order and well worth the wait. The fit, the material, the length - 10/10! I will buy every color they have in these pants they are that good! So flattering! And the quality is incredible! Buy them! For reference I’m 5’9”, 140 - slim build with a booty. I could wear wedges with these pants. So for my tall girls - the length is there! SO. GOOD.",
    "d": "2025-05-15",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Rosalyn Meyers",
    "t": "Love these pants",
    "b": "Fit And material is great",
    "d": "2024-12-16",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 1.0,
    "a": "Dana",
    "t": "",
    "b": "Mala calidad",
    "d": "2024-07-17",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Sarah Johnson",
    "t": "\"Comfort and Style Combined\"",
    "b": "I'm in love with these striped pants! They are incredibly comfortable and stylish, perfect for both lounging at home and going out. The fabric is soft, and the pattern is eye-catching without being too bold. A must-have in anyone's wardrobe!",
    "d": "2024-07-10",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Juliann",
    "t": "",
    "b": "Obsessed with everything",
    "d": "2024-06-29",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Juliann",
    "t": "",
    "b": "The most amazing quality clothing.",
    "d": "2024-06-29",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Emily Martinez",
    "t": "\"Super Fast Shipping – Impressive Service!\"",
    "b": "I was thrilled with how quickly my striped pants arrived. I ordered them on a Monday, and they were at my door by Wednesday. The fast shipping and great customer service have made me a loyal customer. Plus, the pants themselves are fantastic!",
    "d": "2024-05-19",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Daniel Harris",
    "t": "\"Perfect Fit and Stylish Design\"",
    "b": "These striped pants fit like a dream! The design is trendy and flattering, and they go well with so many different tops. I get compliments every time I wear them. This brand really knows how to make great clothing.",
    "d": "2024-05-01",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Jessica Thompson",
    "t": "\"High-Quality Striped Pants That Exceed Expectations!\"",
    "b": "I've been searching for the perfect pair of striped pants, and I finally found them! The quality is incredible; the fabric is durable yet comfortable, and the stitching is flawless. These pants have become my go-to for both casual outings and dressier occasions. Highly recommend!",
    "d": "2024-01-06",
    "u": "/products/the-hailey-trouser-1"
   },
   {
    "r": 5.0,
    "a": "Olivia Brown",
    "t": "\"Amazing Value for Money!\"",
    "b": "I can't believe the price for these striped pants! They are stylish, comfortable, and look way more expensive than they are. It's rare to find such good quality at this price point. I'll definitely be buying more from this brand.",
    "d": "2023-12-12",
    "u": "/products/the-hailey-trouser-1"
   }
  ]
 },
 "The Asher Shorts": {
  "avg": 4.5,
  "count": 2,
  "reviews": [
   {
    "r": 5.0,
    "a": "mariana",
    "t": "LOVE THEM!",
    "b": "These shorts and this set have been my uniform for the summer. The fit is loose and comfortable and the material feels light, which is perfect for these warm days.",
    "d": "2025-08-21",
    "u": "/products/the-asher-shorts-2"
   },
   {
    "r": 4.0,
    "a": "marina alimansky",
    "t": "red",
    "b": "Shorts are nice. my only concern is that the fabric is too thin and crinkles easily. This makes them less practical.",
    "d": "2024-07-22",
    "u": ""
   }
  ]
 },
 "The Bridgett Skirt": {
  "avg": 4.71,
  "count": 17,
  "reviews": [
   {
    "r": 4.0,
    "a": "Janet",
    "t": "",
    "b": "Love love but everything has to be hemmed 6 inches so You spend an extra $50. Only issue.",
    "d": "2026-10-03",
    "u": "/products/the-bridgett-skirt-1"
   },
   {
    "r": 5.0,
    "a": "Jason",
    "t": "",
    "b": "Gorgeous!",
    "d": "2026-04-23",
    "u": "/products/the-bridgett-skirt"
   },
   {
    "r": 5.0,
    "a": "Charlotta",
    "t": "",
    "b": "Love all your items. So soft and great quality. I will be buying more :)",
    "d": "2026-04-10",
    "u": "/products/the-bridgett-skirt-1"
   },
   {
    "r": 5.0,
    "a": "Vanessa",
    "t": "",
    "b": "Pretty. Just fyi its long for shorter girls but very pretty",
    "d": "2025-11-22",
    "u": "/products/the-bridgett-skirt"
   },
   {
    "r": 5.0,
    "a": "Michelle",
    "t": "",
    "b": "Great skirt well made. 27inch waist 39 hips medium was perfect.",
    "d": "2025-07-01",
    "u": "/products/the-bridgett-skirt-1"
   },
   {
    "r": 5.0,
    "a": "Veronica Grail",
    "t": "",
    "b": "So flattering! I’m obsessed",
    "d": "2024-09-14",
    "u": ""
   },
   {
    "r": 1.0,
    "a": "Dana",
    "t": "",
    "b": "Mala calidad",
    "d": "2024-07-17",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Chloe Davis",
    "t": "\"Stylish and Comfortable\"",
    "b": "I’m in love with my new striped skirt! It’s incredibly stylish and comfortable to wear all day long. The fabric is lightweight and breathable, making it perfect for summer. I highly recommend this to anyone looking for a chic and comfy skirt.",
    "d": "2024-07-08",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Tabitha Henry",
    "t": "The Bridgett skirt",
    "b": "This skirt is my Summer staple. So easy to wear and it immediately makes me feel like I put a lot of effort into my outfit by just slipping it on.",
    "d": "2024-06-30",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Katherine Anderson",
    "t": "The Bridgett",
    "b": "Favorite skirt, so many ways I have styled it. It is long but I love that and the elastic waistband in the back!",
    "d": "2024-06-30",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Kim Lopez",
    "t": "The Bridgett Skirt",
    "b": "I have now bought two in black. One to wear with a heel and one to wear with my sandals that I had hemmed! I love it that much!",
    "d": "2024-06-30",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Susan Gibson",
    "t": "Bridgett Skirt",
    "b": "The bridgett skirt is an outfit maker! I get so many compliments on it every time I wear it!",
    "d": "2024-06-30",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Juliann",
    "t": "",
    "b": "Loveeeee",
    "d": "2024-06-29",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Isabella Garcia",
    "t": "\"Fast Shipping and Beautiful Design\"",
    "b": "The fast shipping is just one of the many great things about this purchase. The skirt itself is beautiful and well-made. I’m very happy with my purchase.",
    "d": "2024-05-29",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Mia Wilson",
    "t": "\"Perfect Fit and Lovely Pattern\"",
    "b": "This striped skirt fits me perfectly and the pattern is just lovely. It’s versatile enough to dress up or down, and the quality is excellent. I’m so glad I found this brand. It’s now one of my favorites.",
    "d": "2024-05-22",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Ava Mitchell",
    "t": "\"Great Value for an Amazing Skirt\"",
    "b": "I was pleasantly surprised by the quality of this striped skirt, especially considering the price. It’s stylish and fits perfectly. It's hard to find such a good deal on trendy clothing. I’ll definitely be shopping here again!",
    "d": "2024-01-20",
    "u": ""
   },
   {
    "r": 5.0,
    "a": "Sophia Parker",
    "t": "\"Elegant and Comfortable Striped Skirt!\"",
    "b": "I absolutely love this skirt! The fabric is so soft and comfortable, yet it looks incredibly elegant. Highly recommended!",
    "d": "2024-01-17",
    "u": ""
   }
  ]
 },
 "The New Landon Tank": {
  "avg": 5.0,
  "count": 1,
  "reviews": [
   {
    "r": 5.0,
    "a": "Gina Spencer-Sikandar",
    "t": "Loved!!!",
    "b": "It’s light and feminine. The red is vibrant. I worn it with the matching pants. I was very comfortable and looked very polished.",
    "d": "2024-06-08",
    "u": "/products/the-new-landon"
   }
  ]
 }
};
